import React from "react"
import Layout from "../../../components/layout"
import Hero from "../../../components/olympo/hero"
import WrapperBlock from "../../../components/olympo/wrapperBlock"
import img from "../../../assets/images/heroOlympo35.png"
import { OlympoBlock1 } from "../../../data/olympo35"
import { OlympoBlock2 } from "../../../data/olympo35"
import { OlympoBlock3 } from "../../../data/olympo35"
import { OlympoBlock4 } from "../../../data/olympo35"
import { OlympoBlock5 } from "../../../data/olympo35"
// import { OlympoBlock6 } from "../../../data/olympo35"
import Block1 from "../../../components/olympo/block1"
import ChasisCompatibles from "../../../components/olympo/chasisCompatibles"
// import Block2 from "../../../components/olympo/block2"
import Video35 from '../../../assets/video/Olympo35.mp4'
import ImagenFondoVideo from '../../../assets/images/bus_interprovincial.jpg'
const Olympo35 = () => {
  const [isModal, setModal] = React.useState(false)
  React.useEffect(() => {
    if(window.location.hash.toString()==="#Olympo35"){
      setModal(!isModal)
      
    }
  },[])
  return (
    <Layout
      img={img}
      title="OLYMPO MINA"
      description="Vehículo especial para transportar PERSONAL DE MINA. Diseñado y equipado para RECORRIDOS DE DISTANCIAS LARGAS. Carrocería ROBUSTO, COMPACTO, SALÓN PASAJEROS ESPACIOSO, SEGURO Y ELEGANTE."
    >
      <Hero
        img={img}
        title="OLYMPO MINA"
        subtitle="Buses para personal de mina"
        text="
        <li>Vehículo especial para transportar <b>PERSONAL DE MINA</b>.<br/></li>
        <li>Diseñado y equipado para RECORRIDOS DE <b>DISTANCIAS LARGAS.</b><br/></li>
        <li>Carrocería <b>ROBUSTO, COMPACTO, SALÓN PASAJEROS ESPACIOSO, SEGURO Y ELEGANTE.</b><br/></li> 
        "
        crTitle1="Pasajeros sentados"
        crTitle2="Largo"
        crTitle3="Ancho"
        crTitle4="Altura"
        crTitle5="Chasis"
        crText1="49 pasajeros"
        crText2="12.80 m"
        crText3="2.60 m"
        crText4="3.50 m"
        crText5="VOLVO, VOLKSWAGEN, MB"
        href="#Olympo35"
        isModal={isModal}
        setModal={setModal}
        chasisData={[
          { label: "NRO ASIENTOS", values: ["35 - 39"] },
          { label: "NRO PASAJEROS", values: ["34 - 38"] },
          { label: "LARGO", values: ["9.9 mts"] },
          { label: "ALTO", values: ["3.25 mts"] },
          { label: "ANCHO", values: ["2.4 mts"] },
        ]}
      />
      <ChasisCompatibles
        data={[
          { brand: "HINO", model: "FC BUS", pdf: "/pdf/HINO.pdf" },
        ]}
      />
      <WrapperBlock>
        {/* <Block1 textcolor='red'  data={OlympoBlock6}></Block1> */}
        <Block1 subtitle="SALÓN DE PASAJEROS" data={OlympoBlock1}></Block1>
        <Block1 subtitle="CABINA DE CONDUCTOR" data={OlympoBlock2}></Block1>
        <Block1 subtitle="CONDUCCIÓN" data={OlympoBlock5}></Block1>
        <Block1 subtitle="EXTERIOR" data={OlympoBlock3}></Block1>
        <Block1
          backcolor="gris"
          title="CARACTERÍSTICAS OPCIONALES"
          color="gris"
          data={OlympoBlock4}
        ></Block1>
      </WrapperBlock>
      {isModal&&<div className={`modal`}>
        <div className=" videoContainer">
          <video autoPlay src={Video35} poster={ImagenFondoVideo} controls></video>
          <div className="close"  onClick={()=>setModal(!isModal)}>x</div>
        </div>
      </div>}
    </Layout>
  )
}

export default Olympo35
